import { NoSSR } from '@/components';
import { FeaturedQuizPageView } from '@/module/featured/FeaturedQuizPageView';
import { getDefaultStaticProps } from '@/utils';
export default function FeaturedQuizPage() {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="FeaturedQuizPage" data-sentry-source-file="index.page.tsx">
      <FeaturedQuizPageView data-sentry-element="FeaturedQuizPageView" data-sentry-source-file="index.page.tsx" />
    </NoSSR>;
}
export const getStaticProps = getDefaultStaticProps;